export default {
  'email-verification-label': 'Email Verification Code ({email})',
  'security-method-label': 'Security Verification Method',
  'select-verification-placeholder': 'Please select a verification method',
  'enter-code-label': 'Enter Verification Code',
  'enter-code-placeholder': 'Please enter the verification code',
}
